export default {
  inserted(el) {
    componentHandler.upgradeElements(el);
  },
};



// WEBPACK FOOTER //
// ./src/directives/mdl.js